import * as React from 'react'
import styled from 'styled-components'
import ReactMde from 'react-mde'
import * as constants from '../../static/constants'
import DOMPurify from 'dompurify'

interface IProps {
  name: string
  label: string
  value: string
  previewHtml: string
  placeholder?: string
  required?: boolean
  onChange(nextValue: string): void
}

const MarkdownEditorWithPreview: React.FC<IProps> = props => {
  return (
    <Wrapper>
      <p className="MarkdownEditor_Label">
        {props.label}
        {props.required && <span className="MarkdownEditor_Required">*</span>}
      </p>
      <ContentWrapper>
        <EditorArea>
          <ReactMde
            value={props.value}
            onChange={props.onChange}
            disablePreview={true}
            minEditorHeight={362}
            toolbarCommands={[
              ['header', 'bold', 'italic'],
              ['link', 'quote', 'code'],
              ['unordered-list', 'ordered-list'],
            ]}
            childProps={{
              textArea: {
                placeholder: props.placeholder,
              },
            }}
          />
          <input
            type="hidden"
            name={props.name}
            value={props.value}
            required={props.required}
            readOnly={true}
          />
        </EditorArea>
        <Preview className="public-page">
          <p className="PagePreview_Label">Preview</p>
          <article dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.previewHtml) }} />
        </Preview>
      </ContentWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  .MarkdownEditor_Label {
    margin: 0 0 10px;
    color: #2f3b52;
    font-size: 13px;
    font-weight: 700;
  }

  .MarkdownEditor_Required {
    color: #d04848;
    margin-left: 4px;
  }
`

const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: start;
  gap: 16px;

  @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

const EditorArea = styled.div`
  .mde-header {
    background: #f8fafc;
    border-color: ${constants.COLORS.divider};
  }

  .mde-text {
    font-size: 14px;
    line-height: 1.75;
  }
`

const Preview = styled.div`
  min-height: 362px;
  max-height: 420px;
  overflow-y: auto;
  padding: 20px;
  border: 1px solid ${constants.COLORS.divider};
  border-radius: 4px;
  background: ${constants.COLORS.white};

  .PagePreview_Label {
    margin: 0 0 12px;
    font-weight: 700;
  }
`

export default MarkdownEditorWithPreview
